var _desc, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "232px",
    height: "140px",
    viewBox: "0 0 232 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-1",
    width: 4,
    height: 4,
    x: -2,
    y: -2,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-2",
    transform: "translate(-1054.000000, -630.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-9",
    transform: "translate(1054.000000, 630.000000)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "86.0852969 28.5300001 88.6663686 36.5513617 97.0200005 36.5513617 90.2621128 41.5086386 92.8437778 49.5300001 86.0852969 44.5721243 79.3268161 49.5300001 81.908481 41.5086386 75.1500002 36.5513617 83.503632 36.5513617"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "115.245001 18 112.663859 26.0219605 104.310001 26.0219605 111.068071 30.9792374 108.486337 39 115.245001 34.0427231 122.003665 39 119.42193 30.9792374 126.180001 26.0219605 117.826142 26.0219605"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "145.215298 29.3400002 147.796369 37.3613617 156.150001 37.3613617 149.39152 42.3186386 151.973779 50.3400002 145.215298 45.3821243 138.456224 50.3400002 141.038482 42.3186386 134.280001 37.3613617 142.633633 37.3613617"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "153.163859 64.0018196 144.810001 64.0018196 151.568665 68.9593793 148.986337 76.9800005 155.745594 72.0224408 162.504259 76.9800005 159.921337 68.9593793 166.680001 64.0018196 158.326143 64.0018196 155.745594 55.9800005"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "143.595298 81.9000008 146.176369 89.9215911 154.530001 89.9215911 147.77152 94.8790094 150.353779 102.900001 143.595298 97.9419836 136.836224 102.900001 139.418482 94.8790094 132.660001 89.9215911 141.013633 89.9215911"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "112.663492 105.401221 104.310001 105.401221 111.068255 110.358781 108.485857 118.380001 115.245297 113.422441 122.004145 118.380001 119.421747 110.358781 126.180001 105.401221 117.825916 105.401221 115.245297 97.3800011"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "86.8052969 81.9000008 89.3863686 89.9215911 97.7400004 89.9215911 90.9815196 94.8790094 93.5637777 102.900001 86.8052969 97.9419836 80.0462228 102.900001 82.628481 94.8790094 75.8700001 89.9215911 84.223632 89.9215911"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "71.6632362 64.0014928 63 64.0014928 70.0086866 68.9591012 67.3307043 76.9800005 74.3406093 72.0217989 81.349296 76.9800005 78.6713137 68.9591012 85.6800003 64.0014928 77.0167641 64.0014928 74.3406093 55.9800005"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 231,
    height: 139
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#pattern-1)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003,
    points: "2 2 26 2 26 138 2 138"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration9);
export default __webpack_public_path__ + "static/media/illustration-9.60179473590e91cb3ff1d0f4c4f8d79f.svg";
export { ForwardRef as ReactComponent };